import UsersService from '../services/UsersService';

export default {
    namespaced: true,
    state: {
        users: [],
        loading: false,
    },
    mutations: {
        setLoading(state, loading) {
            state.loading = loading;
        },
        setUsers(state, users) {
            state.users = users;
        }
    },
    actions: {
        loadUsers({commit, state}) {
            if (state.loading) {
                return;
            }
            commit('setLoading', true);
            UsersService.search().then(({data}) => {
                commit('setUsers', data);
                commit('setLoading', false);
            }).catch(err => {
                console.error(err);
                window.alert('Error: Could not load users');
            });
        }
    },
}


// WEBPACK FOOTER //
// ./resources/assets/js/store/users.js